import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { type Audience, FAQS } from "@/content";

/**
 * FAQ — native <details>/<summary> so it's accessible and works with zero JS,
 * styled with the brand tokens. The first item opens by default so the section
 * never reads as an empty stack of closed rows. Questions and order adapt to
 * the active audience (printer vs. broker), mirroring the rest of the page.
 */
export function Faqs({ audience }: { audience: Audience }) {
  const faqs = FAQS[audience];
  return (
    <section id="faq" className="border-t border-[var(--separator)] py-20 sm:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <div className="mb-10 max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-wider text-[var(--muted)]">
            Preguntas frecuentes
          </p>
          <h2 className="mt-3 text-balance text-3xl font-bold tracking-tight text-[var(--foreground)] sm:text-4xl">
            Lo que se suele preguntar en esta etapa.
          </h2>
        </div>

        <div className="divide-y divide-[var(--separator)] overflow-hidden rounded-2xl border border-[var(--separator)] bg-[var(--surface)]">
          {faqs.map((faq, i) => (
            <details key={`${audience}-${faq.q}`} className="group px-5" open={i === 0}>
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5 text-left text-[17px] font-semibold text-[var(--foreground)] [&::-webkit-details-marker]:hidden">
                {faq.q}
                <ChevronDownIcon className="h-5 w-5 shrink-0 text-[var(--muted)] transition-transform duration-200 group-open:rotate-180" />
              </summary>
              <p className="pr-8 pb-5 text-[15px] leading-relaxed text-[var(--muted)]">{faq.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
